import { render, staticRenderFns } from "./payments_index.vue?vue&type=template&id=6f5fc7fe&"
import script from "./payments_index.vue?vue&type=script&lang=js&"
export * from "./payments_index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports